import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TellentAppsEffects } from './store/tellent-apps.effects';
import { TellentAppsNamespace, TellentAppsReducer } from './store/tellent-apps.store';

@NgModule({
  imports: [
    StoreModule.forFeature(TellentAppsNamespace, TellentAppsReducer),
    EffectsModule.forFeature([TellentAppsEffects]),
  ],
})
export class TellentAppsDataModule {}
